"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles = {
    "invosys-ui-FullPageSpinner": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        zIndex: "1200",
        backgroundColor: "rgba(255, 255, 255, 0.7)"
    }
};
exports.default = styles;
